import React from 'react';
import PropTypes from 'prop-types';
import styles from '../icon.scss';

const WaffleMenuIcon = ({ 'aria-hidden': ariaHidden, ...rest }) => (
  <svg
    {...rest}
    className={styles.icon}
    width={32}
    height={32}
    focusable="false"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-icontype="WaffleMenu"
    aria-hidden={ariaHidden}
  >
    <rect x="13.5" y="2" width="5" height="5" rx="1.5" fill="#2C5CA4" />
    <rect x="13.5" y="24" width="5" height="5" rx="1.5" fill="#2C5CA4" />
    <rect x="13.5" y="13" width="5" height="5" rx="1.5" fill="#2C5CA4" />
    <rect x="2" y="2" width="5" height="5" rx="1.5" fill="#2C5CA4" />
    <rect x="2" y="24" width="5" height="5" rx="1.5" fill="#2C5CA4" />
    <rect x="2" y="13" width="5" height="5" rx="1.5" fill="#2C5CA4" />
    <rect x="25" y="2" width="5" height="5" rx="1.5" fill="#2C5CA4" />
    <rect x="25" y="24" width="5" height="5" rx="1.5" fill="#2C5CA4" />
    <rect x="25" y="13" width="5" height="5" rx="1.5" fill="#2C5CA4" />
  </svg>
);
WaffleMenuIcon.displayName = 'WaffleMenuIcon';
WaffleMenuIcon.propTypes = {
  'aria-hidden': PropTypes.bool,
};
export default WaffleMenuIcon;
